import { Container, SqlQuerySpec } from "@azure/cosmos";
import AppStore from "../stores/AppStore";
import ICartLube from "../types/ICartLube";
import AppApi from "./AppApi";

export default class CartLubeApi {
  dbContainer: Container;
  constructor(
    private api: AppApi,
    private store: AppStore,
    dbContainer: Container
  ) {
    this.dbContainer = dbContainer;
  }

  async getAll(token?: string, customerId?: string, limit = 100) {
    if (!token) this.store.cartLube.removeAll();
    let querySpec: string | SqlQuerySpec = "";

    if (customerId) {
      querySpec = {
        query: "SELECT * FROM c WHERE c.customerId = @customerId",
        parameters: [
          {
            name: "@customerId",
            value: customerId,
          },
        ],
      };
    }
    const {
      resources: items,
      continuationToken,
      hasMoreResults,
    } = await this.dbContainer.items
      .query<ICartLube>(querySpec, {
        maxItemCount: limit,
        continuationToken: token,
      })
      .fetchNext();
    this.store.cartLube.load(items);
    return { hasMoreResults, continuationToken };
  }

  async getById(id: string) {
    const { resource: item } = await this.dbContainer
      .item(id)
      .read<ICartLube>();
    if (item) this.store.cartLube.load([item]);
  }

  async create(item: ICartLube) {
    const { resource: createdItem } = await this.dbContainer.items.create(item);
    if (createdItem) this.store.cartLube.load([createdItem]);
  }

  async update(item: ICartLube) {
    const { resource: updatedItem } = await this.dbContainer
      .item(item.id, item.customerId)
      .replace(item);
    if (updatedItem) this.store.cartLube.load([updatedItem]);
  }

  async delete(item: ICartLube) {
    const { resource: result } = await this.dbContainer
      .item(item.id, item.customerId)
      .delete(); // Remove from database
    this.store.cartLube.remove(item.id); // Remove from memory
    return result;
  }
}
